@if (mapData.isLoading()) {
  <div>Loading...</div>
}
@if (mapData.error()) {
  <div>Failed to load data</div>
}

<mat-card>
  <div #exportContent>
    <div class="header">
      <mat-card-title>{{ title() }}</mat-card-title>
      <button
        class="header-btn"
        data-html2canvas-ignore
        mat-icon-button
        (click)="export()"
      >
        <vulcan-icon size="24px" icon="download"></vulcan-icon>
      </button>
    </div>
    <mat-card-content>
      <div class="map-container">
        <tgrid-map [mapId]="mapId()" hideAppState></tgrid-map>

        <div class="legend" #legendContent>
          <span class="legend-title">{{ title() }}</span>
          <div class="legend-bar"></div>
          <div class="legend-container">
            <div class="legend-labels">
              <span>{{ legendMin() | compactNumber }}</span>
              <span>{{ legendMax() | compactNumber }}</span>
            </div>
            <div class="legend-key">
              <div class="legend-item">
                <span class="legend-swatch legend-swatch--no-data"></span>
                <span class="legend-text">No Data</span>
              </div>
              <div class="legend-item">
                <span class="legend-swatch legend-swatch--ntl"></span>
                <span class="legend-text">NTL</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="impacted-counties">
        {{ countyLabelPrefix() }} {{ topCountyNames() }}
      </div>
      <div class="subtitle">{{ subtitle() }}</div>
    </mat-card-content>
  </div>
</mat-card>
